import axios from 'axios';
import { useOnboardingStore } from '../../store/useOnboardingStore';
import { useEffect, useRef, useState, useCallback } from 'react';
import React from 'react';
import debounce from 'lodash.debounce';
import logo from "../../assets/images/logo_2.png";
import { Link } from 'react-router-dom';
import Select from 'react-select';
import useAuthStore from '../../store/useAuthStore';

const mapkey = import.meta.env.VITE_GOOGLE_MAP_API_KEY;

/* ═══════════════════════════════════════════════════
   INJECT STYLES
═══════════════════════════════════════════════════ */
const injectKF = () => {
  if (document.getElementById("ob1-kf")) return;
  const s = document.createElement("style");
  s.id = "ob1-kf";
  s.innerHTML = `
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
vscode-webview://0v4d65fnhqqkqs36q7e8fj4lrkjj67q1vfjirulqoeonk2kdjtor/index.html?id=9f28b2e3-793c-4fc3-b3ba-2f5e316de148&parentId=1&origin=ea0251d1-e2f4-4cbf-a5c9-999be2bc6a45&swVersion=6&extensionId=Anthropic.claude-code&platform=electron&vscode-resource-base-authority=vscode-resource.vscode-cdn.net&parentOrigin=vscode-file%3A%2F%2Fvscode-app&session=56f12199-c9a7-43da-af2b-000fcc2f6b6f#
    @keyframes slideInBot {
      from { opacity:0; transform:translateY(-8px) scale(0.96); }
      to   { opacity:1; transform:translateY(0)    scale(1);    }
    }
    @keyframes botCursor { 0%,100%{opacity:1} 50%{opacity:0} }
    @keyframes speakBar  { 0%,100%{transform:scaleY(1)} 50%{transform:scaleY(1.9)} }
    @keyframes pulseDot  { 0%,100%{opacity:1} 50%{opacity:.35} }
    @keyframes botBobSvg { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-2.5px)} }
    @keyframes floatHeartL1 {
      0%  { transform:translate(0,0)         scale(1);    opacity:1; }
      100%{ transform:translate(-14px,-54px) scale(0.18); opacity:0; }
    }
    @keyframes floatHeartL2 {
      0%  { transform:translate(0,0)        scale(0.82); opacity:0.9; }
      100%{ transform:translate(-4px,-58px) scale(0.12); opacity:0; }
    }
    @keyframes floatHeartL3 {
      0%  { transform:translate(0,0)       scale(0.68); opacity:0.8; }
      100%{ transform:translate(9px,-50px) scale(0.22); opacity:0; }
    }
    @keyframes floatHeartR1 {
      0%  { transform:translate(0,0)        scale(1);    opacity:1; }
      100%{ transform:translate(14px,-54px) scale(0.18); opacity:0; }
    }
    @keyframes floatHeartR2 {
      0%  { transform:translate(0,0)       scale(0.82); opacity:0.9; }
      100%{ transform:translate(4px,-58px) scale(0.12); opacity:0; }
    }
    @keyframes floatHeartR3 {
      0%  { transform:translate(0,0)        scale(0.68); opacity:0.8; }
      100%{ transform:translate(-9px,-50px) scale(0.22); opacity:0; }
    }
    .ob-bot-bob { animation: botBobSvg 3s ease-in-out infinite; }
    .ob-hl1 { animation: floatHeartL1 2s 0.0s  ease-out infinite; transform-origin: 23px 27px; }
    .ob-hl2 { animation: floatHeartL2 2s 0.65s ease-out infinite; transform-origin: 23px 27px; }
    .ob-hl3 { animation: floatHeartL3 2s 1.3s  ease-out infinite; transform-origin: 23px 27px; }
    .ob-hr1 { animation: floatHeartR1 2s 0.2s  ease-out infinite; transform-origin: 49px 27px; }
    .ob-hr2 { animation: floatHeartR2 2s 0.85s ease-out infinite; transform-origin: 49px 27px; }
    .ob-hr3 { animation: floatHeartR3 2s 1.5s  ease-out infinite; transform-origin: 49px 27px; }

    .ob-wrap { position:fixed; z-index:99999; animation:slideInBot .28s cubic-bezier(.34,1.2,.64,1) both; }
    .ob-wrap::before { content:''; position:absolute; width:16px; height:9px; background:#c0001a; clip-path:polygon(50% 0%,100% 100%,0% 100%); }
    .ob-wrap.below::before  { top:-9px;    left:24px; }
    .ob-wrap.above::before  { bottom:-9px; left:24px; transform:rotate(180deg); }
    .ob-wrap.toright::before{ top:24px;    left:-9px; transform:rotate(-90deg); }
    .ob-wrap.toleft::before { top:24px;    right:-9px; transform:rotate(90deg); }

    .ob-card { background:#fff; border-radius:14px; border:1px solid rgba(0,0,0,.07); overflow:hidden; box-shadow:0 4px 8px rgba(0,0,0,.06),0 18px 52px rgba(0,0,0,.18),0 2px 10px rgba(192,0,26,.1); }
    .ob-hd { background:linear-gradient(135deg,#c0001a 0%,#8b0000 58%,#5c0000 100%); padding:12px 14px 10px; display:flex; align-items:center; gap:10px; position:relative; overflow:visible; }
    .ob-hd::after { content:''; position:absolute; inset:0; pointer-events:none; background-image:linear-gradient(rgba(255,255,255,.04) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,.04) 1px,transparent 1px); background-size:16px 16px; }
    .ob-av { position:relative; flex-shrink:0; z-index:1; overflow:visible; }
    .ob-bars { display:flex; align-items:flex-end; gap:2px; position:absolute; bottom:-3px; right:-4px; background:rgba(0,0,0,.3); border-radius:4px; padding:2px 3px; z-index:2; }
    .ob-b { width:2.5px; border-radius:2px; background:#fff; transform-origin:bottom; }
    .ob-b:nth-child(1){ height:4px;  animation:speakBar .48s .00s ease-in-out infinite; }
    .ob-b:nth-child(2){ height:9px;  animation:speakBar .48s .10s ease-in-out infinite; }
    .ob-b:nth-child(3){ height:6px;  animation:speakBar .48s .20s ease-in-out infinite; }
    .ob-b:nth-child(4){ height:3px;  animation:speakBar .48s .30s ease-in-out infinite; }
    .ob-meta { flex:1; z-index:1; min-width:0; overflow:hidden; }
    .ob-name { font-size:11.5px; font-weight:800; color:#fff; letter-spacing:.06em; font-family:'DM Mono','Fira Code',monospace; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
    .ob-sub  { font-size:9.5px; color:rgba(255,255,255,.7); display:flex; align-items:center; gap:4px; margin-top:2px; }
    .ob-dot  { width:5px; height:5px; border-radius:50%; background:#6effa0; box-shadow:0 0 4px rgba(100,255,150,.85); flex-shrink:0; animation:pulseDot 2s ease-in-out infinite; }
    .ob-badge{ z-index:1; flex-shrink:0; background:rgba(255,255,255,.16); border:1px solid rgba(255,255,255,.3); border-radius:20px; padding:2px 8px; font-size:10px; font-weight:700; color:#fff; white-space:nowrap; }
    .ob-tag { background:linear-gradient(90deg,#fff5f5,#fff); border-bottom:1px solid rgba(192,0,26,.1); padding:5px 14px; display:flex; align-items:center; gap:6px; }
    .ob-tag-dot { width:5px; height:5px; border-radius:50%; background:#c0001a; flex-shrink:0; }
    .ob-tag-txt { font-size:9.5px; font-weight:800; color:#c0001a; letter-spacing:.08em; }
    .ob-body { padding:10px 14px 8px; }
    .ob-msg  { font-size:13px; line-height:1.62; color:#1a1a1a; word-break:break-word; margin:0; }
    .ob-msg strong { color:#c0001a; font-weight:800; }
    .ob-cur  { display:inline-block; width:2px; height:13px; background:#c0001a; border-radius:2px; margin-left:2px; vertical-align:middle; animation:botCursor .65s ease-in-out infinite; }
    .ob-ft   { padding:8px 14px 11px; display:flex; align-items:center; justify-content:space-between; gap:8px; border-top:1px solid rgba(0,0,0,.05); background:#fafafa; }
    .ob-dots { display:flex; gap:4px; align-items:center; }
    .ob-d    { width:6px; height:6px; border-radius:50%; background:#e0e0e0; transition:all .3s; }
    .ob-d.on { width:18px; border-radius:999px; background:linear-gradient(90deg,#c0001a,#8b0000); }
    .ob-skip { background:none; border:none; cursor:pointer; font-size:11px; color:#c0c0c0; padding:4px 6px; border-radius:6px; transition:all .18s; white-space:nowrap; }
    .ob-skip:hover { background:#f0f0f0; color:#888; }
    .ob-next { background:linear-gradient(135deg,#c0001a,#8b0000); color:#fff; border:none; border-radius:8px; padding:7px 16px; font-size:12px; font-weight:800; cursor:pointer; letter-spacing:.03em; box-shadow:0 3px 12px rgba(192,0,26,.32); transition:all .18s; white-space:nowrap; }
    .ob-next:hover  { transform:translateY(-1px); box-shadow:0 5px 16px rgba(192,0,26,.46); }
    .ob-next:active { transform:scale(.97); }

    .ob1-section { background:#f8f5f0 !important; min-height:100vh !important; }

    .ob1-prog-wrap { display:flex !important; gap:5px !important; margin-top:10px !important; }
    .ob1-prog-bar  { height:4px !important; border-radius:999px !important; flex:1 !important; background:#e2e8f0 !important; }
    .ob1-prog-bar.active { background:linear-gradient(90deg,#c0001a,#8b0000) !important; }

    /* ── Mobile: compact, overlap-safe bot popup ── */
    @media (max-width: 767px) {
      .ob-wrap    { max-width:calc(100vw - 24px); }
      .ob-card    { border-radius:10px; }
      .ob-hd      { padding:7px 8px 6px; gap:6px; }
      .ob-av svg  { width:34px !important; height:34px !important; }
      .ob-bars    { padding:1px 2px; bottom:-2px; right:-2px; }
      .ob-b       { width:1.5px; }
      .ob-name    { font-size:9px; letter-spacing:.03em; }
      .ob-sub     { font-size:7.5px; }
      .ob-dot     { width:4px; height:4px; }
      .ob-badge   { font-size:8px; padding:1px 5px; }
      .ob-tag     { padding:3px 8px; }
      .ob-tag-dot { width:4px; height:4px; }
      .ob-tag-txt { font-size:7.5px; }
      .ob-body    { padding:6px 8px 5px; }
      .ob-msg     { font-size:11px; line-height:1.4; }
      .ob-ft      { padding:5px 8px 7px; }
      .ob-skip    { font-size:9px; padding:2px 4px; }
      .ob-next    { font-size:10px; padding:5px 10px; }
      .ob-d       { width:4px; height:4px; }
      .ob-d.on    { width:12px; }
    }

    /* ── Location field group — dedicated classes so they can't collide
       with the project's global (mis-scoped) .col-6 override ── */
    .loc-field-row { display:flex; flex-wrap:wrap; gap:8px; }
    .loc-field-col { flex: 1 1 calc(50% - 4px); min-width: 0; }
    @media (min-width: 768px) {
      .loc-field-col { flex: 1 1 0; }
    }
  `;
  document.head.appendChild(s);
};

/* ═══════════════════════════════════════════════════
   BOT FACE SVG
═══════════════════════════════════════════════════ */
const BotFaceSVG: React.FC = () => (
  <svg width="64" height="64" viewBox="0 0 72 72" fill="none" style={{ overflow: "visible" }}>
    <defs>
      <style>{`
        .ob-bot-bob { animation: botBobSvg 3s ease-in-out infinite; }
        .ob-hl1 { animation: floatHeartL1 2s 0.0s  ease-out infinite; transform-origin: 23px 27px; }
        .ob-hl2 { animation: floatHeartL2 2s 0.65s ease-out infinite; transform-origin: 23px 27px; }
        .ob-hl3 { animation: floatHeartL3 2s 1.3s  ease-out infinite; transform-origin: 23px 27px; }
        .ob-hr1 { animation: floatHeartR1 2s 0.2s  ease-out infinite; transform-origin: 49px 27px; }
        .ob-hr2 { animation: floatHeartR2 2s 0.85s ease-out infinite; transform-origin: 49px 27px; }
        .ob-hr3 { animation: floatHeartR3 2s 1.5s  ease-out infinite; transform-origin: 49px 27px; }
      `}</style>
    </defs>
    <g className="ob-bot-bob">
      <line x1="36" y1="10" x2="36" y2="3" stroke="rgba(255,255,255,0.82)" strokeWidth="2.5" strokeLinecap="round" />
      <circle cx="36" cy="2" r="3.2" fill="rgba(255,255,255,0.9)" />
      <rect x="7" y="10" width="58" height="46" rx="15" fill="rgba(255,255,255,0.97)" />
      <circle cx="7" cy="32" r="5.5" fill="rgba(255,255,255,0.85)" stroke="rgba(192,0,26,0.45)" strokeWidth="1.2" />
      <circle cx="65" cy="32" r="5.5" fill="rgba(255,255,255,0.85)" stroke="rgba(192,0,26,0.45)" strokeWidth="1.2" />
      <rect x="11" y="17" width="24" height="20" rx="9" fill="#c0001a" />
      <rect x="37" y="17" width="24" height="20" rx="9" fill="#8b0000" />
      <ellipse cx="23" cy="27" rx="9" ry="8" fill="white" />
      <ellipse cx="49" cy="27" rx="9" ry="8" fill="white" />
      <g className="ob-hl1"><path d="M23,33 C23,33 12,23 12,17 C12,13 17,11 23,17 C29,11 34,13 34,17 C34,23 23,33 23,33Z" fill="#ff3d6b" /></g>
      <g className="ob-hl2"><path d="M23,33 C23,33 12,23 12,17 C12,13 17,11 23,17 C29,11 34,13 34,17 C34,23 23,33 23,33Z" fill="#c0001a" opacity="0.88" /></g>
      <g className="ob-hl3"><path d="M23,33 C23,33 12,23 12,17 C12,13 17,11 23,17 C29,11 34,13 34,17 C34,23 23,33 23,33Z" fill="#ff7099" /></g>
      <g className="ob-hr1"><path d="M49,33 C49,33 38,23 38,17 C38,13 43,11 49,17 C55,11 60,13 60,17 C60,23 49,33 49,33Z" fill="#ff3d6b" /></g>
      <g className="ob-hr2"><path d="M49,33 C49,33 38,23 38,17 C38,13 43,11 49,17 C55,11 60,13 60,17 C60,23 49,33 49,33Z" fill="#c0001a" opacity="0.88" /></g>
      <g className="ob-hr3"><path d="M49,33 C49,33 38,23 38,17 C38,13 43,11 49,17 C55,11 60,13 60,17 C60,23 49,33 49,33Z" fill="#ff7099" /></g>
      <path d="M16,46 Q36,60 56,46" stroke="#c0001a" strokeWidth="2.8" strokeLinecap="round" fill="none" />
      <ellipse cx="12" cy="44" rx="6" ry="4" fill="rgba(255,100,100,0.2)" />
      <ellipse cx="60" cy="44" rx="6" ry="4" fill="rgba(255,100,100,0.2)" />
      <line x1="7" y1="28" x2="2" y2="23" stroke="rgba(255,255,255,0.78)" strokeWidth="2.4" strokeLinecap="round" />
      <line x1="7" y1="36" x2="2" y2="39" stroke="rgba(255,255,255,0.78)" strokeWidth="2.4" strokeLinecap="round" />
      <line x1="65" y1="28" x2="70" y2="23" stroke="rgba(255,255,255,0.78)" strokeWidth="2.4" strokeLinecap="round" />
      <line x1="65" y1="36" x2="70" y2="39" stroke="rgba(255,255,255,0.78)" strokeWidth="2.4" strokeLinecap="round" />
    </g>
  </svg>
);

/* ═══════════════════════════════════════════════════
   TYPES + BOT STEPS
═══════════════════════════════════════════════════ */
type BotSide = "below" | "above" | "toright" | "toleft";
interface StepData { tag: string; plain: string; html: React.ReactNode; sideLg: BotSide; }

// Shared sizing constants — used by BotPopup for its own box AND by Step1
// to size the spacer that pushes page content down so the popup never
// overlaps the next form field/MCQ.
const GAP = 8;
const POPUP_W_MOBILE = 230, POPUP_W_DESKTOP = 310;
const POPUP_H_MOBILE = 130, POPUP_H_DESKTOP = 240;

const BOT_STEPS: StepData[] = [
  { tag: "STEP 1 OF 7 — GENDER",       plain: "First, select your gender — Male or Female?",           html: <>👋 First, <strong>select your gender</strong> — Male or Female?</>,             sideLg: "below" },
  { tag: "STEP 2 OF 7 — DATE OF BIRTH", plain: "Enter your date of birth — you must be 18 or older!", html: <>🎂 <strong>Enter your date of birth</strong> — you must be 18 or older!</>,     sideLg: "below" },
  { tag: "STEP 3 OF 7 — YOUR LOCATION", plain: "Tell us your city and state — zipcode will auto-fill!", html: <>📍 <strong>Tell us your city and state</strong> — zipcode will auto-fill!</>, sideLg: "below" },
  { tag: "STEP 4 OF 7 — YOUR EMAIL",    plain: "Enter your email — you'll use this to login!",         html: <>📧 <strong>Enter your email</strong> — you'll use this to login!</>,           sideLg: "below" },
  { tag: "STEP 5 OF 7 — YOUR PASSWORD", plain: "Choose a strong password and confirm it below!",       html: <>🔒 <strong>Choose a strong password</strong> and confirm it below!</>,         sideLg: "below" },
  { tag: "STEP 6 OF 7 — TERMS",         plain: "Read the Terms & Privacy Policy and tick the box!",    html: <>✅ Read the <strong>Terms &amp; Privacy</strong> and tick the box!</>,         sideLg: "below" },
  { tag: "STEP 7 OF 7 — ALL SET!",      plain: "All set? Tap Continue to finish registration!",        html: <>🚀 All set? <strong>Tap Continue</strong> to finish registration!</>,          sideLg: "below" },
];

const TOTAL = BOT_STEPS.length;

/* ═══════════════════════════════════════════════════
   BOT POPUP
═══════════════════════════════════════════════════ */
interface PopupProps {
  anchorRef: React.RefObject<HTMLDivElement | null>;
  step: number;
  data: StepData;
  onSkip: () => void;
  onNext: () => void;
  nextLabel: string;
}

const BotPopup: React.FC<PopupProps> = ({ anchorRef, step, data, onSkip, onNext, nextLabel }) => {
  // Mobile gets a smaller card so it never overlaps form fields or screen edges.
  const isMobileScreen = typeof window !== "undefined" && window.innerWidth < 768;
  const PW = isMobileScreen ? POPUP_W_MOBILE : POPUP_W_DESKTOP;
  const POPUP_H = isMobileScreen ? POPUP_H_MOBILE : POPUP_H_DESKTOP;

  const [pos, setPos] = useState<{ top: number; left: number; width: number } | null>(null);
  const [activeSide, setActiveSide] = useState<BotSide>("below");
  const [displayed, setDisplayed] = useState("");
  const [done, setDone] = useState(false);
  const [status, setStatus] = useState("typing...");
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const retryRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const calcPos = useCallback((): boolean => {
    if (!anchorRef.current) return false;
    const r = anchorRef.current.getBoundingClientRect();
    const vw = window.innerWidth, vh = window.innerHeight;
    if (r.width === 0 && r.height === 0) return false;

    // Popup always appears BELOW the anchor — never above, never to the side.
    // It hugs the anchor's own left edge (not screen-center) so it visually
    // sits directly under the field it refers to.
    if (vw < 768) {
      const popW = Math.min(vw - 16, PW);
      const top = Math.max(8, Math.min(r.bottom + GAP, vh - POPUP_H - 8));
      let left = r.left;
      left = Math.max(8, Math.min(left, vw - popW - 8));
      setActiveSide("below");
      setPos({ top, left, width: popW });
      return true;
    }

    let left = r.left;
    if (left + PW > vw - 8) left = vw - PW - 8;
    left = Math.max(12, Math.min(left, vw - PW - 12));

    const top = Math.max(8, Math.min(r.bottom + GAP, vh - POPUP_H - 8));

    setActiveSide("below");
    setPos({ top, left, width: PW });
    return true;
  }, [anchorRef]);

  useEffect(() => {
    let attempts = 0; const MAX = 50;
    if (retryRef.current) clearTimeout(retryRef.current);
    setPos(null);
    const tryCalc = () => { const ok = calcPos(); if (!ok && attempts < MAX) { attempts++; retryRef.current = setTimeout(tryCalc, 80); } };
    tryCalc();
    window.addEventListener("resize", calcPos);
    window.addEventListener("scroll", calcPos, true);
    return () => {
      if (retryRef.current) clearTimeout(retryRef.current);
      window.removeEventListener("resize", calcPos);
      window.removeEventListener("scroll", calcPos, true);
    };
  }, [calcPos, step]);

  useEffect(() => {
    setDisplayed(""); setDone(false); setStatus("typing...");
    let i = 0;
    const tick = () => {
      if (i <= data.plain.length) { setDisplayed(data.plain.slice(0, i)); i++; timerRef.current = setTimeout(tick, 21); }
      else { setDone(true); setStatus("Online — here to guide you!"); }
    };
    tick();
    return () => { if (timerRef.current) clearTimeout(timerRef.current); };
  }, [data.plain, step]);

  if (!pos) return null;
  const isSide = activeSide === "toright" || activeSide === "toleft";

  return (
    <div
      className={`ob-wrap ${activeSide}`}
      style={{ top: pos.top, left: pos.left, width: pos.width, transform: isSide ? "translateY(-50%)" : "none" }}
    >
      <div className="ob-card" style={{ width: "100%" }}>
        <div className="ob-hd">
          <div className="ob-av">
            <BotFaceSVG />
            <div className="ob-bars"><div className="ob-b" /><div className="ob-b" /><div className="ob-b" /><div className="ob-b" /></div>
          </div>
          <div className="ob-meta">
            <div className="ob-name">SLAMMMM GUIDE</div>
            <div className="ob-sub"><div className="ob-dot" /><span>{status}</span></div>
          </div>
          <div className="ob-badge">{step}/{TOTAL}</div>
        </div>
        <div className="ob-tag"><div className="ob-tag-dot" /><div className="ob-tag-txt">{data.tag}</div></div>
        <div className="ob-body">
          {done
            ? <p className="ob-msg">{data.html}</p>
            : <p className="ob-msg">{displayed}<span className="ob-cur" /></p>
          }
        </div>
        <div className="ob-ft">
          <div className="ob-dots">
            {Array.from({ length: TOTAL }).map((_, i) => (
              <div key={i} className={`ob-d${i + 1 === step ? " on" : ""}`} />
            ))}
          </div>
          <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
            <button className="ob-skip" onClick={onSkip}>Skip guide</button>
            <button className="ob-next" onClick={onNext}
              onMouseEnter={e => { (e.currentTarget as HTMLButtonElement).style.transform = "translateY(-1px)"; }}
              onMouseLeave={e => { (e.currentTarget as HTMLButtonElement).style.transform = "none"; }}
            >{nextLabel}</button>
          </div>
        </div>
      </div>
    </div>
  );
};

/* ═══════════════════════════════════════════════════
   STEP 1 — MAIN COMPONENT
═══════════════════════════════════════════════════ */
const Step1 = () => {
  const {
    questions, selectOption, currentStep, inputs,
    handleInputChange, errors, validate,
    registerLoading, simpleRegister,
  } = useOnboardingStore();

  const { emailExistMessage, checkEmail } = useAuthStore();
  const stepQuestions = questions.filter((q: any) => q.step === currentStep);

  const today = new Date();
  const minAge = 18;
  const maxYear = today.getFullYear() - minAge;
  const months = Array.from({ length: 12 }, (_, i) => i + 1);
  const days = Array.from({ length: 31 }, (_, i) => i + 1);
  const years = Array.from({ length: 100 }, (_, i) => maxYear - i);

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [buttonHighlight, setButtonHighlight] = useState(false);
  const typingTimeout = useRef<number | null>(null);

  /* ── Bot state ── */
  const [guideStep, setGuideStep] = useState<number | null>(null);
  const autoAdvancedRef = useRef<Set<number>>(new Set());

  /* Track viewport width so the spacer (which pushes content down while the
     bot is showing) matches the popup's actual mobile/desktop size. */
  const [viewportW, setViewportW] = useState(typeof window !== "undefined" ? window.innerWidth : 1024);
  useEffect(() => {
    const onResize = () => setViewportW(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  const spacerH = (viewportW < 768 ? POPUP_H_MOBILE : POPUP_H_DESKTOP) + GAP + 8;

  /* Renders an invisible spacer right after a bot-guide anchor. This pushes
     the next form field down in normal document flow so the fixed-position
     bot popup (which floats below the anchor) never overlaps/hides it. */
  const BotSpacer = ({ n }: { n: number }) => (
    <div style={{ height: guideStep === n ? spacerH : 0, transition: "height .2s ease" }} />
  );

  const refGender   = useRef<HTMLDivElement>(null);
  const refDob      = useRef<HTMLDivElement>(null);
  const refCity     = useRef<HTMLDivElement>(null);
  const refEmail    = useRef<HTMLDivElement>(null);
  const refPassword = useRef<HTMLDivElement>(null);
  const refTerms    = useRef<HTMLDivElement>(null);
  const refContinue = useRef<HTMLDivElement>(null);
  const botRefs = [refGender, refDob, refCity, refEmail, refPassword, refTerms, refContinue];

  useEffect(() => {
    injectKF();
    const seen = localStorage.getItem("step1Guide");
    if (!seen) {
      localStorage.setItem("step1Guide", "true");
      setTimeout(() => setGuideStep(1), 400);
    }
  }, []);

  useEffect(() => {
    if (guideStep === null) return;
    const el = botRefs[guideStep - 1]?.current;
    if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
  }, [guideStep]);

  const nextBot = useCallback(() => setGuideStep(p => (p !== null && p < TOTAL) ? p + 1 : null), []);
  const skipBot = useCallback(() => setGuideStep(null), []);

  const autoAdvanceBot = useCallback((targetStep: number) => {
    if (autoAdvancedRef.current.has(targetStep)) return;
    autoAdvancedRef.current.add(targetStep);
    setTimeout(() => {
      setGuideStep(prev => {
        if (prev === targetStep - 1 || prev === targetStep) return targetStep;
        return prev;
      });
    }, 550);
  }, []);

  /* Bot guide highlight — NO zIndex on sections that contain dropdowns
     to avoid creating stacking contexts that clip react-select menus.
     Only non-dropdown sections (gender, terms, continue) get zIndex boost. */
  const gw = (n: number): React.CSSProperties => {
    const hasDropdown = n === 2 || n === 3; // DOB and City/State have react-select
    if (n === 7) return { position: "relative" };
    if (hasDropdown) return { position: "relative" }; // no zIndex — dropdowns portal to body
    return { position: "relative", zIndex: guideStep === n ? 9500 : 1 };
  };

  const validateAge = (day?: string, month?: string, year?: string) => {
    if (!day || !month || !year) return true;
    const dob = new Date(+year, +month - 1, +day);
    const cut = new Date(today.getFullYear() - minAge, today.getMonth(), today.getDate());
    if (dob > cut) { handleInputChange("dobError", "You must be at least 18 years old."); return false; }
    handleInputChange("dobError", ""); return true;
  };

  const hitMapApiByCity = async (city: string) => {
    if (!city) return;
    try {
      const r = await axios.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${city}&key=${mapkey}&sensor=false`);
      if (r.data.status === "OK" && r.data.results[0]) {
        const { lat, lng } = r.data.results[0].geometry.location;
        handleInputChange("lat", lat);
        handleInputChange("lang", lng);
        const z = await axios.get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${mapkey}&sensor=false`);
        if (z.data.status === "OK" && z.data.results[0]) {
          const ac = z.data.results[0].address_components;
          handleInputChange("zipcode", ac.find((c: any) => c.types.includes("postal_code"))?.long_name || "");
          handleInputChange("state", ac.find((c: any) => c.types.includes("administrative_area_level_1"))?.short_name || "");
        }
      } else {
        const backup = await axios.get('https://ipapi.co/json/');
        if (backup.data?.latitude) {
          handleInputChange("lat", backup.data.latitude);
          handleInputChange("lang", backup.data.longitude);
        }
      }
    } catch (error) {
      try {
        const backup = await axios.get('https://ipapi.co/json/');
        if (backup.data?.latitude) {
          handleInputChange("lat", backup.data.latitude);
          handleInputChange("lang", backup.data.longitude);
        }
      } catch (e) {
        console.error("[Location] All geocoding methods failed.");
      }
    }
  };

  const handleNext = () => setCurrentIndex(p => p + 1);

  const handleChange = (value: string, key: string) => {
    handleInputChange(key, value);
    if (typingTimeout.current) clearTimeout(typingTimeout.current);
    typingTimeout.current = window.setTimeout(() => { handleInputChange(key, value); handleNext(); }, 2000);
  };

  const handleOptionSelect = (idx: number, qId: number, oId: number) => {
    selectOption(qId, oId);
    if (stepQuestions[idx].selected === "") {
      handleNext();
      autoAdvanceBot(2);
    }
  };

  const handleSubmit = async (e: React.MouseEvent) => {
    e.preventDefault(); e.stopPropagation();
    if (inputs["dobError"]) return;
    if (validate()) await simpleRegister();
  };

  const debouncedCity = useCallback(debounce((c: string) => { if (c) hitMapApiByCity(c); }, 500), []);
  useEffect(() => { debouncedCity(inputs["city"]); }, [inputs["city"]]);

  /* ── react-select shared styles ──
     menuPortalTarget + menuPosition="fixed" ensures the dropdown menu
     renders in document.body, escaping ALL stacking contexts. */
  const sel = {
    control: (b: any) => ({
      ...b,
      backgroundColor: "transparent",
      borderColor: "#888",
      borderRadius: "50px",
      minHeight: "38px",
      boxShadow: "none",
      cursor: "pointer",
    }),
    menu: (b: any) => ({ ...b, zIndex: 100000 }),
    menuPortal: (b: any) => ({ ...b, zIndex: 100000 }),
    valueContainer: (b: any) => ({ ...b, padding: "0 8px" }),
    dropdownIndicator: (b: any) => ({
      ...b,
      padding: "8px",
      color: "#1a202c",
    }),
    option: (b: any, state: any) => ({
      ...b,
      backgroundColor: state.isSelected ? "#c0001a" : state.isFocused ? "#fff0f0" : "#fff",
      color: state.isSelected ? "#fff" : "#1a202c",
      cursor: "pointer",
    }),
  };

  const opts = (arr: number[], pad = false) =>
    arr.map(v => ({ value: pad ? String(v).padStart(2, "0") : String(v), label: pad ? String(v).padStart(2, "0") : String(v) }));

  const stateAbbreviations = [
    { short: "AL", full: "Alabama" }, { short: "AK", full: "Alaska" }, { short: "AZ", full: "Arizona" }, { short: "AR", full: "Arkansas" },
    { short: "CA", full: "California" }, { short: "CO", full: "Colorado" }, { short: "CT", full: "Connecticut" }, { short: "DE", full: "Delaware" },
    { short: "FL", full: "Florida" }, { short: "GA", full: "Georgia" }, { short: "HI", full: "Hawaii" }, { short: "ID", full: "Idaho" },
    { short: "IL", full: "Illinois" }, { short: "IN", full: "Indiana" }, { short: "IA", full: "Iowa" }, { short: "KS", full: "Kansas" },
    { short: "KY", full: "Kentucky" }, { short: "LA", full: "Louisiana" }, { short: "ME", full: "Maine" }, { short: "MD", full: "Maryland" },
    { short: "MA", full: "Massachusetts" }, { short: "MI", full: "Michigan" }, { short: "MN", full: "Minnesota" }, { short: "MS", full: "Mississippi" },
    { short: "MO", full: "Missouri" }, { short: "MT", full: "Montana" }, { short: "NE", full: "Nebraska" }, { short: "NV", full: "Nevada" },
    { short: "NH", full: "New Hampshire" }, { short: "NJ", full: "New Jersey" }, { short: "NM", full: "New Mexico" }, { short: "NY", full: "New York" },
    { short: "NC", full: "North Carolina" }, { short: "ND", full: "North Dakota" }, { short: "OH", full: "Ohio" }, { short: "OK", full: "Oklahoma" },
    { short: "OR", full: "Oregon" }, { short: "PA", full: "Pennsylvania" }, { short: "RI", full: "Rhode Island" }, { short: "SC", full: "South Carolina" },
    { short: "SD", full: "South Dakota" }, { short: "TN", full: "Tennessee" }, { short: "TX", full: "Texas" }, { short: "UT", full: "Utah" },
    { short: "VT", full: "Vermont" }, { short: "VA", full: "Virginia" }, { short: "WA", full: "Washington" }, { short: "WV", full: "West Virginia" },
    { short: "WI", full: "Wisconsin" }, { short: "WY", full: "Wyoming" },
  ];
  const stateOpts = stateAbbreviations.map(s => ({ value: s.short, label: s.full }));
  const countryOpts = [{ label: "USA", value: "USA" }];

  const handleEmailBlur = async () => {
    const email = inputs["email"];
    if (!email) return;
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      handleInputChange("emailFormatError", "Please enter a valid email address.");
      handleInputChange("emailAvailable", "");
      return;
    }
    handleInputChange("emailFormatError", "");
    try {
      await checkEmail(email);
      if (!useAuthStore.getState().emailExistMessage) {
        handleInputChange("emailAvailable", "This email looks good!");
        autoAdvanceBot(5);
      } else {
        handleInputChange("emailAvailable", "");
      }
    } catch (e) { console.error(e); }
  };

  return (
    <>
      {/* Bot popup — floats freely at z-index:99999, no overlay */}
      {guideStep !== null && guideStep >= 1 && guideStep <= TOTAL && (
        <BotPopup
          anchorRef={botRefs[guideStep - 1]}
          step={guideStep}
          data={BOT_STEPS[guideStep - 1]}
          onSkip={skipBot}
          onNext={guideStep < TOTAL ? nextBot : skipBot}
          nextLabel={guideStep < TOTAL ? "Next →" : "Done ✓"}
        />
      )}

      {/* Navbar */}
      <nav className="navbar navbar-expand-lg navbar-light bg-primary">
        <div className="container justify-content-center">
          <Link className="navbar-brand" to="/"><img src={logo} alt="" className="img-fluid" /></Link>
        </div>
      </nav>

      <section className="ob1-section onboarding_main_wraper py-60">
        <div className="container">
          <div className="row">
            <div className="col-xl-8 col-lg-10 offset-xl-2 offset-lg-1">

              <div className="onboarding_step_top_wraper mb-4">
                <h2 className="mb-1" style={{ fontFamily: "'Inter',sans-serif", fontWeight: 800, letterSpacing: "-.02em" }}>
                  Basic Information
                </h2>
                <p style={{ color: "#94a3b8", fontSize: 13, fontFamily: "'Inter',sans-serif", marginBottom: 10 }}>
                  Question 1/6
                </p>
                <div className="ob1-prog-wrap">
                  <div className="ob1-prog-bar active" />
                  <div className="ob1-prog-bar" />
                  <div className="ob1-prog-bar" />
                  <div className="ob1-prog-bar" />
                  <div className="ob1-prog-bar" />
                  <div className="ob1-prog-bar" />
                </div>
              </div>

              <form className="onboarding_form" onSubmit={e => e.preventDefault()} onKeyDown={e => { if (e.key === "Enter") e.preventDefault(); }}>
                {stepQuestions.length > 0 ? (
                  <>
                    {/* ── GENDER — Bot Step 1 anchor ── */}
                    {(currentIndex >= 0 || stepQuestions[0]?.selected !== "") && (
                      <div ref={refGender} className="form_group" style={gw(1)}>
                        <label className="form-label w-100">{stepQuestions[0].question}</label>
                        <div className="btn-group custom_radio_group" role="group">
                          {stepQuestions[0].questions_options.map((opt: any) => (
                            <div key={opt.id}>
                              <input
                                type="radio"
                                defaultChecked={stepQuestions[0].selected === opt.id}
                                id={`opt-${opt.id}`}
                                className="btn-check"
                                name="gender"
                              />
                              <label
                                className="btn btn-outline-secondary"
                                htmlFor={`opt-${opt.id}`}
                                onClick={() => handleOptionSelect(0, stepQuestions[0].id, opt.id)}
                                aria-pressed={stepQuestions[0].selected === opt.id}
                              >{opt.option}</label>
                            </div>
                          ))}
                        </div>
                        {errors["question"] && <p className="text-danger text-sm mt-1">{errors["question"]}</p>}
                      </div>
                    )}
                    <BotSpacer n={1} />

                    {/* ── DOB — Bot Step 2 anchor ──
                        menuPortalTarget={document.body} prevents dropdown clipping */}
                    <div
                      ref={refDob}
                      className={`form_group ${currentIndex >= 1 || inputs["dob-month"] != null ? "slide-in" : "slide-out"}`}
                      style={gw(2)}
                    >
                      <label className="form-label w-100">When's your birthday?</label>
                      <div className="row g-2">
                        <div className="col-4 col-sm-4 col-md-3">
                          <Select
                            components={{ IndicatorSeparator: () => null }}
                            options={opts(months, true)}
                            placeholder="Month"
                            styles={sel}
                            classNamePrefix="react-select"
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            value={opts(months, true).find(o => o.value === inputs["dob-month"]) || null}
                            onChange={v => {
                              handleInputChange("dob-month", v?.value ?? "");
                              validateAge(inputs["dob-day"], v?.value, inputs["dob-year"]);
                            }}
                          />
                        </div>
                        <div className="col-4 col-sm-4 col-md-3">
                          <Select
                            components={{ IndicatorSeparator: () => null }}
                            options={opts(days, true)}
                            placeholder="Day"
                            styles={sel}
                            classNamePrefix="react-select"
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            value={opts(days, true).find(o => o.value === inputs["dob-day"]) || null}
                            onChange={v => {
                              handleInputChange("dob-day", v?.value ?? "");
                              validateAge(v?.value, inputs["dob-month"], inputs["dob-year"]);
                            }}
                          />
                        </div>
                        <div className="col-4 col-sm-4 col-md-3">
                          <Select
                            components={{ IndicatorSeparator: () => null }}
                            options={opts(years)}
                            placeholder="Year"
                            styles={sel}
                            classNamePrefix="react-select"
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            value={opts(years).find(o => o.value === inputs["dob-year"]) || null}
                            onChange={v => {
                              handleInputChange("dob-year", v?.value ?? "");
                              const valid = validateAge(inputs["dob-day"], inputs["dob-month"], v?.value);
                              if (valid) {
                                handleNext();
                                autoAdvanceBot(3);
                              }
                            }}
                          />
                        </div>
                      </div>
                      {errors["dob"] && <p className="text-danger text-sm mt-1">{errors["dob"]}</p>}
                      {inputs["dobError"] && <p className="text-danger text-sm mt-1">{inputs["dobError"]}</p>}
                    </div>
                    <BotSpacer n={2} />

                    {/* ── CITY / STATE — Bot Step 3 anchor ──
                        menuPortalTarget={document.body} prevents dropdown clipping */}
                    <div
                      ref={refCity}
                      className={`form_group ${currentIndex >= 2 || inputs["city"] != null ? "slide-in" : "slide-out"}`}
                      style={gw(3)}
                    >
                      <label className="form-label w-100">What city or country do you live in?</label>
                      <div
                        style={viewportW < 768 ? {
                          border: "1px solid rgba(192,0,26,0.12)",
                          borderRadius: "18px",
                          padding: "14px 14px 12px",
                          background: "rgba(192,0,26,0.025)",
                        } : undefined}
                      >
                        {viewportW < 768 && (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 6,
                              marginBottom: 10,
                              fontSize: 11.5,
                              fontWeight: 700,
                              color: "#c0001a",
                              letterSpacing: "0.06em",
                              textTransform: "uppercase",
                            }}
                          >
                            <i className="fa-solid fa-location-dot" style={{ fontSize: 11 }} />
                            Location
                          </div>
                        )}
                        <div className="loc-field-row">
                          <div className="loc-field-col">
                            <Select
                              components={{ IndicatorSeparator: () => null }}
                              value={countryOpts[0]}
                              options={countryOpts}
                              styles={sel}
                              isDisabled
                              menuPortalTarget={document.body}
                              menuPosition="fixed"
                              classNamePrefix="form-select"
                            />
                          </div>
                          <div className="loc-field-col">
                            <input
                              type="text"
                              value={inputs["city"] || ""}
                              className="form-control"
                              placeholder="Enter City"
                              style={{ borderRadius: "50px", minHeight: "38px" }}
                              onChange={e => {
                                handleInputChange("city", e.target.value);
                                handleNext();
                              }}
                              onBlur={() => {
                                if (inputs["city"]) autoAdvanceBot(4);
                              }}
                            />
                            {errors["city"] && <p className="text-danger text-sm mt-1">{errors["city"]}</p>}
                          </div>
                          <div className="loc-field-col">
                            <Select
                              components={{ IndicatorSeparator: () => null }}
                              classNamePrefix="react-select"
                              options={stateOpts}
                              value={stateOpts.find(o => o.value === inputs["state"]) || null}
                              placeholder="Search state"
                              isSearchable
                              maxMenuHeight={180}
                              noOptionsMessage={() => "No matching state"}
                              styles={sel}
                              menuPortalTarget={document.body}
                              menuPosition="fixed"
                              onChange={v => {
                                handleInputChange("state", v?.value || "");
                                handleNext();
                                if (inputs["city"]) autoAdvanceBot(4);
                              }}
                            />
                            {errors["state"] && <p className="text-danger text-sm mt-1">{errors["state"]}</p>}
                          </div>
                          <div className="loc-field-col">
                            <input
                              className="form-control"
                              value={inputs["zipcode"] || ""}
                              placeholder="Zip Code"
                              style={{ borderRadius: "50px", minHeight: "38px" }}
                              onChange={e => handleInputChange("zipcode", e.target.value)}
                            />
                            {errors["zipcode"] && <p className="text-danger text-sm mt-1">{errors["zipcode"]}</p>}
                          </div>
                        </div>
                      </div>
                    </div>
                    <BotSpacer n={3} />

                    {/* ── EMAIL — Bot Step 4 anchor ── */}
                    <div
                      ref={refEmail}
                      className={`form_group ${currentIndex >= 3 ? "slide-in" : "slide-out"}`}
                      style={gw(4)}
                    >
                      <label className="form-label w-100">We just need your email to get started!</label>
                      <div className="row">
                        <div className="col-md-6">
                          <input
                            type="email"
                            name="email"
                            autoComplete="username"
                            className="form-control"
                            value={inputs["email"] || ""}
                            placeholder="Type email here..."
                            onChange={e => handleInputChange("email", e.target.value)}
                            onBlur={handleEmailBlur}
                          />
                          {inputs["emailFormatError"] && <p className="text-danger text-sm mt-1">{inputs["emailFormatError"]}</p>}
                          {emailExistMessage && !inputs["emailFormatError"] && <p className="text-danger text-sm mt-1">{emailExistMessage}</p>}
                          {inputs["emailAvailable"] && !emailExistMessage && !inputs["emailFormatError"] && <p className="text-success text-sm mt-1">{inputs["emailAvailable"]}</p>}
                        </div>
                      </div>
                    </div>
                    <BotSpacer n={4} />

                    {/* ── PASSWORD — Bot Step 5 anchor ── */}
                    <div
                      ref={refPassword}
                      className={`form_group ${currentIndex >= 4 || inputs["password"] != null ? "slide-in" : "slide-out"}`}
                      style={gw(5)}
                    >
                      <label className="form-label w-100">Choose password</label>
                      <div className="row g-3">
                        <div className="col-md-4 col-sm-6">
                          <div className="form_field_right_icon">
                            <input
                              autoComplete="new-password"
                              type={showPassword ? "text" : "password"}
                              name="password"
                              className="form-control"
                              placeholder="Password"
                              value={inputs["password"] || ""}
                              onChange={e => handleInputChange("password", e.target.value)}
                            />
                            <i
                              className={`fa-solid ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
                              onClick={() => setShowPassword(p => !p)}
                              style={{ cursor: "pointer" }}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 col-sm-6">
                          <div className="form_field_right_icon">
                            <input
                              type={showConfirmPassword ? "text" : "password"}
                              name="confirm-password"
                              className="form-control"
                              placeholder="Confirm Password"
                              autoComplete="new-password"
                              defaultValue={inputs["confirm-password"] || ""}
                              onChange={e => handleChange(e.target.value, "confirm-password")}
                              onBlur={() => {
                                handleNext();
                                if (inputs["password"] && inputs["confirm-password"]) autoAdvanceBot(6);
                              }}
                            />
                            <i
                              className={`fa-solid ${showConfirmPassword ? "fa-eye-slash" : "fa-eye"}`}
                              onClick={() => setShowConfirmPassword(p => !p)}
                              style={{ cursor: "pointer" }}
                            />
                          </div>
                          {errors["confirm-password"] && <p className="text-danger text-sm mt-1">{errors["confirm-password"]}</p>}
                        </div>
                      </div>
                      {errors["password"] && <p className="text-danger text-sm mt-1">{errors["password"]}</p>}
                    </div>
                    <BotSpacer n={5} />

                    {/* ── TERMS — Bot Step 6 anchor ── */}
                    <div
                      ref={refTerms}
                      className={`form_group ${currentIndex >= 5 || inputs["tc_pp_agree"] != null ? "slide-in" : "slide-out"}`}
                      style={gw(6)}
                    >
                      <div className="form-check onboarding_agree_checkbox">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="gridCheck"
                          value="1"
                          defaultChecked={inputs["tc_pp_agree"] === "1"}
                          onChange={e => {
                            handleInputChange("tc_pp_agree", e.target.value);
                            setButtonHighlight(true);
                            setTimeout(() => setButtonHighlight(false), 1000);
                            if (e.target.checked) autoAdvanceBot(7);
                          }}
                        />
                        <label className="form-check-label" htmlFor="gridCheck">
                          By checking this box, you agree to our{" "}
                          <a href="/terms" target="_blank" rel="noopener noreferrer">Terms of Use</a>. Learn how we process your data in our{" "}
                          <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
                        </label>
                      </div>
                      {errors["tc_pp_agree"] && <p className="text-danger text-sm mt-1">{errors["tc_pp_agree"]}</p>}
                    </div>
                    <BotSpacer n={6} />

                    {useOnboardingStore.getState().error && (
                      <div className="alert alert-danger py-2 small mt-2" role="alert">
                        {useOnboardingStore.getState().error}
                      </div>
                    )}
                  </>
                ) : <p>No questions available for this step.</p>}

                {/* ── Buttons — Bot Step 7 anchor ── */}
                <div className="d-flex justify-content-between mt-5">
                  <Link to="/signup" className="btn btn-outline-secondary">
                    <i className="fa-solid fa-arrow-left me-2" />Back
                  </Link>

                  <div ref={refContinue}>
                    <button
                      type="button"
                      className={`btn btn-primary${buttonHighlight ? " glow-shake" : ""}`}
                      disabled={registerLoading}
                      onClick={handleSubmit}
                    >
                      {registerLoading
                        ? <><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />Processing…</>
                        : <>Continue <i className="fa-solid fa-arrow-right ms-2" /></>
                      }
                    </button>
                  </div>
                </div>
                <BotSpacer n={7} />

              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Step1;